import { TProductCleanUpdated } from '@Arti-zen/package-backoffice'
import { Box, Button, CircularProgress, IconButton, Modal, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import DownloadButton from 'components/DownloadButton'
import { useAppSelector } from 'hooks/useStore'
import { ReactElement, useState } from 'react'
import styled from 'styled-components'
import { ApiArtizenBO } from 'utils/artizenConnector'

export default function ArtisanExtracts(): ReactElement {
  const { artisan } = useAppSelector((state) => state.artisan)
  const [clients, setClients] = useState([])
  const [products, setProducts] = useState([])
  const [productsCleaned, setProductsCleaned] = useState<TProductCleanUpdated[] | null>(null)
  const [interventions, setInterventions] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const getClients = async () => {
    setIsLoading(true)
    const clientList = await ApiArtizenBO.extracts.getClientsByCompany(artisan.id)
    setClients(clientList)
    setIsLoading(false)
  }

  const getProducts = async () => {
    setIsLoading(true)
    const productList = await ApiArtizenBO.extracts.getProductsByCompany(artisan.id)
    setProducts(productList)
    setIsLoading(false)
  }

  const cleanProducts = async () => {
    setIsLoading(true)
    const result = await ApiArtizenBO.products.cleanProductsByCompany(String(artisan.id))
    setProductsCleaned(result)
    setIsLoading(false)
  }

  const getInterventions = async () => {
    setIsLoading(true)
    const interventionList = await ApiArtizenBO.extracts.getInterventionsByCompany(artisan.id)
    setInterventions(interventionList)
    setIsLoading(false)
  }

  if (isLoading) {
    return (
      <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress aria-label="Loading…" />
      </div>
    )
  }

  return (
    <Wrapper>
      {clients.length > 0 ? (
        <DownloadButton
          data={clients}
          fileName={`${artisan.id}_clients_${new Date().toISOString()}`}
          label={'Récupérer csv clients'}
          size="medium"
        />
      ) : (
        <Button variant="contained" onClick={getClients}>
          Clients
        </Button>
      )}

      {/* {products.length > 0 ? (
        <DownloadButton
          data={products}
          fileName={`${artisan.id}_products_${new Date().toISOString()}`}
          label={'Récupérer csv produits'}
          size="medium"
        />
      ) : (
        <Button variant="contained" onClick={getProducts}>
          Produits
        </Button>
      )} */}

      {interventions.length > 0 ? (
        <DownloadButton
          data={interventions}
          fileName={`${artisan.id}_interventions_${new Date().toISOString()}`}
          label={'Récupérer csv interventions'}
          size="medium"
        />
      ) : (
        <Button variant="contained" onClick={getInterventions}>
          Interventions
        </Button>
      )}

      <Button variant="contained" color="error" onClick={cleanProducts}>
        Nettoyer produits descriptions
      </Button>

      <Modal open={productsCleaned !== null} onClose={() => setProductsCleaned(null)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            minWidth: 340,
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" fontWeight={600}>
              Nettoyage des produits
            </Typography>
            <IconButton size="small" onClick={() => setProductsCleaned(null)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: 'success.main' }}>
            <CheckCircleOutlineIcon />
            <Typography variant="body1">
              <strong>{productsCleaned?.length}</strong> produit{productsCleaned?.length !== 1 ? 's' : ''} nettoyé
              {productsCleaned?.length !== 1 ? 's' : ''}
            </Typography>
          </Box>

          <DownloadButton
            data={productsCleaned}
            fileName={`${artisan.id}_productsCleaned_${new Date().toISOString()}`}
            label={'Récupérer csv produits nettoyés'}
            size="medium"
          />
        </Box>
      </Modal>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 50px;
`
